import { FilterInput } from '@/network/graphql.g'
import { BridgeProduct } from '@/types/bridgeProduct'

interface ProductListDataObj {
  products?: BridgeProduct[]
  page?: number
}

export interface ProductListData {
  categoryId?: string
  filterInput?: string
  productList?: ProductListDataObj[]
}

const productListKey = 'productList'

export const setLocalDataIS = (
  productList: BridgeProduct[],
  page: number,
  filterInput: FilterInput[],
  categoryId: string
): void => {
  const productListData: ProductListData = getProducstFromStorage()

  if (
    !productListData ||
    productListData?.categoryId != categoryId ||
    productListData?.filterInput != JSON.stringify(filterInput)
  ) {
    const productObj: [ProductListDataObj] = [
      {
        page: page,
        products: productList
      }
    ]
    setProductsToStorage(productObj, filterInput, categoryId)
    return
  }

  const productListUpdate = productListData.productList

  const pageExists = productListUpdate.some((item) => item.page === page)

  if (!pageExists) {
    productListUpdate.push({
      products: productList,
      page: page
    })

    setProductsToStorage(productListUpdate, filterInput, categoryId)
  }
}

const getProducstFromStorage = (): ProductListData => {
  return localStorage.getItem(productListKey)
    ? JSON.parse(localStorage.getItem(productListKey))
    : null
}

export const getProducstFromStorageByPage = (page: number): ProductListData => {
  const productList: ProductListData = getProducstFromStorage()

  if (!getProducstFromStorage) {
    return null
  }

  const productListPage: ProductListDataObj[] = []

  productList.productList.forEach((productsObj) => {
    if (productsObj.page <= page) {
      productListPage.push(productsObj)
    }
  })

  productList.productList = productListPage

  return productList
}

const setProductsToStorage = (
  productObj: ProductListDataObj[],
  filterInput: FilterInput[],
  categoryId: string
) => {
  const data: ProductListData = {
    categoryId: categoryId,
    filterInput: JSON.stringify(filterInput),
    productList: productObj
  }

  localStorage.setItem(productListKey, JSON.stringify(data))
}
